export default __webpack_public_path__ + "static/media/entergy_h_w_2021.7f79a5f2.png";